import React from "react";
import Accordion from "web/react/components/accordion/accordion";
import LeadLink from "web/react/components/lead-link/lead-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import styles from "./affiliate-options.css";

export interface AffiliateOption {
    url: string;
    price: string;
    image: string;
    domain: string;
    retailer_name: string;
    sale_price?: string;
}

export interface AffiliateOptionsProps {
    title: string;
    options: AffiliateOption[];
}

function AffiliateOptions({ title, options }: AffiliateOptionsProps): React.ReactElement {
    function onAccordionOpened({ accordionName, nonInteraction }): void {
        analytics.event("buy_area", "open_option", accordionName, nonInteraction);
    }

    function onAccordionClosed({ accordionName, nonInteraction }): void {
        analytics.event("buy_area", "close_option", accordionName, nonInteraction);
    }

    return (
        <Accordion
            name="affiliate"
            onAccordionOpened={onAccordionOpened}
            onAccordionClosed={onAccordionClosed}
        >
            <Accordion.Title>
                <h4 className={styles.title}>{title}</h4>
            </Accordion.Title>
            <Accordion.Content>
                <div className={styles.options}>
                    {options.map((option, index) => (
                        <LeadLink
                            key={index}
                            className={styles.option}
                            rel="nofollow"
                            href={option.url}
                            reason="from-other-stores"
                            openInNewTab
                        >
                            <img className={styles.optionImage} src={option.image} />
                            <div className={styles.optionPrice}>
                                {option.sale_price && option.sale_price !== option.price ? (
                                    <>
                                        <del>{option.price}</del>
                                        <span className={styles.optionSalePrice}>
                                            {option.sale_price}
                                        </span>
                                    </>
                                ) : (
                                    <span>{option.price}</span>
                                )}
                            </div>
                            <div className={styles.optionMessage}>
                                <SVGIcon className={styles.hyperlinkIcon} name="hyperlink" />
                                <span>{`Available from ${option.retailer_name}`}</span>
                            </div>
                        </LeadLink>
                    ))}
                </div>
            </Accordion.Content>
        </Accordion>
    );
}

export default AffiliateOptions;
